import React from 'react'
import { EmptyState } from '@enamelai/design-system'
import './SettingsPlaceholderStyle.css'

interface SettingsPlaceholderProps {
  title: string
}

const SettingsPlaceholder = ({
  title,
}: SettingsPlaceholderProps): React.ReactElement => (
  <EmptyState
    className="settings-placeholder-empty"
    iconClass="mgc mgc_tool_fill"
    title={`${title} is coming soon`}
    description="This settings page has not been implemented yet."
  />
)

export default SettingsPlaceholder
